import React from 'react';
import {CircleFilledChip, RenewIcon} from '../../../../components/buttons/IconButtons';
import CustomUserChip from '../../../../components/CustomUserChip';
import {POSITION_MODEL} from '../../../../Helpers/PositionModel';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import {TABS_KITCHEN} from '../Model/Models';
import CustomTooltip from '../../../../components/CustomTooltip';
import ConnectionStatusApp from "../Functionality/ConnectionStatusApp";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param boolean isOnline: Variable that indicates whether the WebSocket is open
 * @param event setModified: State that updates whether a manual WebSocket connection is required
 * @param boolean activeStep: Variable to indicate which tab is active
 * @param model item: model of header section
 */
const KitchenStatus = ({ isOnline, setModified, activeStep, item }) => {
    const {
        t,
        hour,
        dateFormat
    } = ConnectionStatusApp();

    return (
        <div className='d-flex align-items-center gap-3'>
            {activeStep === TABS_KITCHEN.ORDERS.INDEX &&
                <>
                    <p className="fs-16px ibl-font-w-500 font-color-general-950">{t("status")+ ":"}</p>
                    <CustomUserChip
                        className={`mt-0 mx-0 px-0 text-nowrap ${ (item.date == null || item.cafeteria == null) ? 'chip-shades-150-200' : isOnline ? 'chip-success-150-100' : 'chip-error-code-150-100'}`}
                        variant={'large'}
                        Icon={CircleFilledChip}
                        showAvatar={true}
                        name={t( (item.date == null || item.cafeteria == null) ? 'select_date_and_cafeteria' : isOnline ? "online" : "offline" )
                        }
                        iconPosition={POSITION_MODEL.LEFT}
                        classNameIcon={"icon-color-primary-700"}
                    />
                </>
            }

            <div className={`icon-color-shades-400 w-40px h-24px ${isOnline ? 'cursor-not-allowed' : 'cursor-pointer icon-hover-shades-950' }`}>
                <CustomTooltip text={!isOnline && t('renew')}>
                    <RenewIcon
                        width={40}
                        height={24}
                        onClick={()=>{
                            setModified(true);
                        }}
                    />
                </CustomTooltip>
            </div>

            <div className='d-flex align-items-center gap-4 w-100'>
                <p className="fs-20px ibl-font-w-300 font-color-general-950">{dateFormat}</p>
                <p className="fs-20px ibl-font-w-300 font-color-general-950 text-container-clock">{hour.format('HH:mm:ss')}</p>
            </div>
        </div>
    );
};

export default KitchenStatus
